import Cookies from 'js-cookie';

export const getCookie = (name = 'user', prop?: string) => {
  const cookie = Cookies.get(name);

  if (cookie) {
    const parsedCookie = JSON.parse(cookie);
    if (prop) {
      return parsedCookie[prop];
    }
    return parsedCookie;
  }

  return null;
};

export const removeCookie = (name = 'user', prop?: string) => {
  if (prop) {
    const cookie = Cookies.get(name);
    if (cookie) {
      const cookieObj = JSON.parse(cookie);
      delete cookieObj[prop];
      Cookies.set(name, JSON.stringify(cookieObj), { expires: 7 });
    }
  } else {
    Cookies.remove(name);
  }
};